export const useContact = () => {
  return {
    title: 'Informações de Contato',
    email: 'victorneil08@gmail.com',
    phone: '+55 (91) 98117-9825',
    location: 'Belém, PA - Brasil',
    linkedinUrl: 'https://www.linkedin.com/in/neil-lima-706606248',
    githubUrl: 'https://github.com/Neil-Lima',
  };
};
